import {create} from 'zustand';
import {devtools, persist} from 'zustand/middleware';

export const createStore = (store, key) => create(devtools(store, {name: key}))
export const persistStore = (store, key, config) => create(persist(devtools(store, {name: key}), config))
export const selector = state => state